<template>
    <div class="terms">
        <div class="terms-head">
            <i v-if="!isPortrait" class="" style="width: 40px;height: 20px;"></i>
            <div class="terms-head-title" :style="{ 'padding-left': isPortrait ? '20px' : '0px' }">
                起亚汽车有限公司个人信息保护声明
            </div>
            <i  class="el-icon-close" style="font-size: 20px;padding-right: 20px;" @click="goback"></i>
        </div>
        <!-- <i v-if="!isPortrait" class="el-icon-close" style="font-size: 20px;" @click="goback"></i> -->
        <div style="height: 80px;"></div>
        <div class="terms-content" v-for="item in context" :key="item.title">
            <div class="terms-content-title">{{ item.title }}</div>
            <div class="terms-content-text">{{ item.text }}</div>
        </div>
    </div>
</template>
<script>
import { isPortraitFun } from '@/utils/utils';
export default {
    name: "terms",
    data() {
        return {
            isPortrait: isPortraitFun(),
            context: [
                {
                    title: "",
                    text: "江苏悦达起亚汽车有限公司（以下简称“我们”）向您提供车辆，配件及其他附属产品（以下统称为“产品”）及与产品相关的众多网上和线下服务，包括但不限于我们的网站，车载信息系统和其他车载技术，商品展览交流及其他服务（以下统称为“服务”）。当您与我们和/或我们的关联公司就产品和服务取得联系时，都可能会被要求提供您的个人信息。我们非常重视您的个人信息保护与个人隐私，也理解您可能关心您的个人信息是如何被使用和共享的，因此我们制订了本隐私政策，阐述了我们如何收集，使用，披露，共享以及储存您的个人信息。请您仔细阅读本隐私政策，当您阅读完毕并继续提供您的个人信息或购买、使用商品和接受服务，表示您已完全理解并接受本隐私政策的全部条款和内容。"
                }, {
                    title: "个人信息范围",
                    text: "本隐私政策所称“个人信息”，是指我们从个人收集的可用于识别特定个人身份的信息，其中又可分为能够单独使用的个人信息（如姓名、身份证信息）和不能单独使用而必须与其他信息结合使用的个人信息（如位置信息、车辆状况）。我们所收集的个人信息可能同时包括这两类信息。上述个人信息，我们只会在事先告知并取得您同意的情况下收集；\n我们可能向您收集的“个人信息”包括但不限于您的姓名、邮寄地址、电话号码、电子邮件地址、其他联系方式、年龄、出生日期、性别、学历、职业、语言、邮编、区号、个人图像、兴趣偏好、身份证信息、驾照信息、信用卡信息、唯一设备标识符、地理位置信息、车辆状态、行为信息等。"
                }, {
                    title: "个人信息收集目的",
                    text: "管理我们的产品和服务，向您提供我们的产品及服务，并就您使用我们的产品与服务的情况进行及时沟通；将我们向您提供的产品和服务进行个性化定制（包括地区化定制以及个人化定制），使您在使用我们的产品与服务时有更好的个性化体验；                    支持我们服务的履行与运作，回应您的咨询及请求，处理您的交易；                    向您提供售后服务及支持，接收您的反馈；将我们的最新产品，服务，衍生产品及服务，活动预告，抽奖，竞赛或促销推广活动等及时告知您；                    将您的个人信息用于数据分析和研究等内部目的，以改进我们的产品，服务和与客户之间的沟通，及时解决客户的问题；                    使用个人信息向您发送产品/ 服务安全的重要通知，例如召回及市场行动等信息。由于这些信息对您的人身安全至关重要，我们强烈建议您不要拒绝接收此类信息；                调查已经发生的或者可能发生的欺诈情形或者其他非法活动；                在任何情况下，为了提供并完善我们的产品，服务，内容和广告，我们也可能会将您的个人信息和非个人信息结合在一起进行分析研究。                为了数据统计和分析的目的，我们的平台集成合作方的秒针分析 SDK。秒针分析 SDK 将获取您的页面浏览行为数据。若您想进一步了解秒针的个人信息保护政策，您可以前往 https://miaozhen.com/cn/privacy 进行查看                我们不会在违反上述个人信息收集目的的情况下，或超出本隐私政策的范围外使用您的个人信息。"
                }, {
                    title: "个人信息的收集途径",
                    text: "我们可以通过多种方式收集和存储您的个人信息，包括但不限于以下内容：当您访问或者参与我们的官网或者其他网上服务时（例如您通过我们的网站或者电子邮件联系我们提出问题、进行评论或者参与在线调查时），您自愿向我们提供的信息；            当您为了获得我们的线下服务而进行注册时（例如您申请试驾或者参加我们的品牌俱乐部）；            当您下载或使用我们或我们指定的公司开发的应用（如车载系统）；            当您关注我们的社交媒体（如微博、微信）时；            当您通过公众可接触的方式（社交媒体网站如BBS、微博和微信）发布个人信息时；            我们可以收集并将您的个人信息添加到我们的客户数据库的其他方法。"
                }, {
                    title: "通过Cookies收集信息",
                    text: "我们会通过Cookies和其他追踪技术了解客户使用我们网站的情况。Cookies是一种能够识别您设备的特定识别符号，通过识别您的设备，我们可以为您推荐个性化商品和广告（包括由本网站提供广告内容的联盟网站）。我们将通过Cookies收集的信息分类汇总，用于向不同群体客户提供更有针对性、更有价值的产品信息和服务。通过Cookies收集的信息属于不能单独使用的个人信息，您理解并同意我们将通过Cookies收集的信息与您的其他信息结合使用。大部分网页浏览器会自动打开Cookies，但您可以随时调整您的浏览器设置，选择关闭Cookies。然而，Cookies能让您享受我们更优质、更个性化的服务，如果您关闭了Cookies，可能无法完全体验或者我们网站上提供的所有服务，所以我们建议您将其设置为打开状态。"
                }, {
                    title: "个人信息的处理和储存",
                    text: "我们不会在违背您的个人信息收集目的的情况下，或超出本隐私政策的范围处理、泄漏、篡改、毁损您的个人信息。在我们存储您的个人数据时，我们设置了合理且足够的安保措施来保护您的个人信息免受未经授权的访问、泄露和丢失，包括但不限于电子安全措施和物理安全措施。一旦发生或者可能发生个人信息泄露、毁损、丢失的情况，我们将会立即采取补救措施。"
                }, {
                    title: "个人信息的完整性及更新",
                    text: "目前我们还不提供用户注册服务，因此您如果通过填写表单向我们您提交的个人信息，目前可通过拨打客服电话[400-799-0000]或重新提交更新的信息来提示我们您的信息已发生更新。您还有权要求我们不使用这些信息。我们将切实尊重您的意愿。但是，特定的法规，尤其与安全问题或者财务有关的法规，可能会禁止更改您的信息。"
                }, {
                    title: "向第三方披露和共享您的个人信息",
                    text: "我们尊重您的个人隐私并遵守相关的法律法规，我们承诺严格保密所收集的个人信息，并且不会将您的个人信息出售给他人。我们仅会为达到个人信息收集目的，与遵守本隐私政策或至少提供与本隐私政策同样保护性政策的以下第三方分享您的个人信息。除非另有声明，这些第三方并不代表起亚收集、使用或转移个人信息等。因此，起亚并不对这些第三方收集、使用或转移个人信息等行为负责。我们的关联公司及附属公司：为确保本公司集团成员向您提供大致相当的服务质量，我们可能会与我们的关联公司以及附属公司共享您的个人信息。            我们的授权经销商：授权经销商是我们的销售渠道，他们负责向您介绍、销售我们的产品及服务。为更好地提供售前和售后服务，我们会与授权经销商共享与个人信息收集目的有关的您的个人信息。            金融性公司、车辆保险相关的公司、二手车公司、产品延长保修期运作公司：我们会同他们共享您的车辆融资相关的个人信息、二手车评估及销售相关的个人信息、产品延长保修期相关的个人信息。            商业合作伙伴：我们与众多第三方有业务上的合作往来，为促进合作、推出优质及更新的产品及服务，我们可能会与第三方合作伙伴共享您的个人信息。            第三方服务提供者：我们聘请第三方公司（如供应商、服务外包商等）为我们的客户提供相关服务，包括但不限于购车贷款、车辆保险、车载信息、路边救援、电话回访、发送信函、电子邮件或短信、清理客户信息、分析数据、提供市场营销帮助、客户满意度调查、接受客户咨询以及处理客户请求等等。此类第三方仅能为履行其职责或协助我们达到个人信息收集目的而访问、使用、处理或保留您的个人信息。除此以外，他们不能将您的个人信息用于任何其他目的。            呼叫中心：我们会设置呼叫中心，以统一接收您的请求与反馈，提高我们的服务质量。为有效地为您提供服务，我们可能会向呼叫中心提供您的个人信息。            业务转让：为持续发展我们的业务，我们可能会进行重组、合并或出售某些业务。当我们的资产因此被转移至相关第三方时，我们收集的一切个人信息也会随之转让给相关第三方。            调查或审计：受适用的法律法规，我们可能会受到相关政府机构或监管部门不时的调查或审计。在相关调查或审计程序中，如果我们被要求披露您的个人信息而无法立即告知您该等披露，您同意我们在这些调查或审计程序中向相关第三方披露您的个人信息而无须获得您的额外同意。其他：应其他法律和法规、法律程序、法院命令、诉讼和/ 或公共机构和政府部门的要求，或者就国家安全、执法活动或具有公众重要性的其他事宜，或者为了执行我们的条款和条件或保护我们的经营或用户，披露您的个人信息是必须的或适当的，我们也可能会向相关第三方披露您的个人信息。        当您另行同意时：当您另行同意或者给与我们指示时，我们可以向第三方披露您的个人信息。"
                }, {
                    title: "联系我们",
                    text: "如果您对上述政策内容或对您的个人信息保护有任何咨询或疑问，或您希望查阅我们所有持有的您的个人信息的内容，或要求对您所提供的个人信息做出更正，或者发现我们违反法律、行政法规的规定或者双方的约定收集、使用其个人信息，或者发现我们收集、存储的其个人信息有错误的。请通过拨打客户电话[400-799-0000]方式与我们联系。我们将会收到您的询问/要求后尽快给予答复。该答复是免费的，除非提供该答复的成本或要求提供该答复的频率是不合理的。"
                }
            ]
        }
    },
    methods: {
        goback(){
            this.$router.push({
                path: '/'
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.terms {
    color: #05141f;
    background-color: #FFF;
    &-head {
        position: fixed;
        width: 100%;
        display: flex;
        flex-direction: row;
        padding: 20px 0;
        // background-color: rgba(5, 20, 31, 1);
        background-color: #FFF;
        // justify-content: space-around;
        justify-content: space-between;
        align-items: center;

        &-title {
            font-family: "zhonghei";
            font-size: 18px;
            line-height: 1.5;
            color: #05141f;
            font-weight: bolder;
        }
    }

    &-content {
        padding: 15px 20px;

        &-title {
            font-family: "KiaSignatureRegular", "方正兰亭", "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 16px;
            line-height: 1.5;
            color: #05141F;
        }

        &-text {
            font-family: "heijian";
            font-size: 14px;
            line-height: 1.8;
            color: #05141FCC;
        }
    }

}
</style>